import { deviceTypes } from '@/enums/device';

export const isLoRaWanGatewayDevice = (deviceType: string): boolean => {
  return deviceType == deviceTypes.LoRaWanGateway;
};

export const isSmartRadiatorThermostatDevice = (
  deviceType: string
): boolean => {
  return deviceType == deviceTypes.SmartRadiatorThermostat;
};

export const isSmokeDetectorDevice = (deviceType: string): boolean => {
  return deviceType === deviceTypes.SmokeDetector;
};

export const isDirectMeterGatewayDevice = (deviceType: string): boolean => {
  return deviceType === deviceTypes.DirectMeterGateway;
};

export const isHeatCostAllocatorDevice = (deviceType: string): boolean => {
  return deviceType === deviceTypes.HeatCostAllocator;
};

export const isLegacyMeteringDevice = (deviceType: string): boolean => {
  return (
    deviceType === deviceTypes.LegacyHeatMeter ||
    deviceType === deviceTypes.LegacyWarmWaterMeter ||
    deviceType === deviceTypes.LegacyWaterMeter
  );
};
